<template>
  <md-dialog
    :md-active.sync="dialog"
    :md-click-outside-to-close="false"
    :md-close-on-esc="false"
    @md-clicked-outside="closeDialog"
  >
    <md-dialog-title>Rechazo de proceso</md-dialog-title>
    <div class="md-layout md-alignment-center-center">
      <div class="md-layout-item md-size-90">
        <md-field>
          <label>Al menos 10 carácteres</label>
          <md-textarea v-model="payload"></md-textarea>
        </md-field>
      </div>
    </div>
    <md-dialog-actions>
      <md-button class="md-danger md-simple" @click="closeDialog"
        >Cancelar</md-button
      >
      <md-button
        class="md-success"
        :disabled="!enableSend"
        @click="$emit('rejectCP', payload)"
        >Enviar</md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "RejectDialog",
  props: {
    dialog: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      payload: null
    };
  },
  computed: {
    enableSend() {
      return this.payload && this.payload.length >= 10;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="css" scoped>
.md-layout {
  width: 560px;
}
</style>


// WEBPACK FOOTER //
// src/pages/RoadSinisters/CloseProject/RejectDialog.vue